module.exports = __webpack_public_path__ + "media/gem-found-green.f99ff7d8.mp4";